import { useState } from "react";
import { StaticDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { delay } from "../../utils";

function DatePicker({ ShowModal = null, onDateChange = null }) {
    const currentDate = new Date();
    const [currentType, setCurrentType] = useState("year");
    const [dateValues, setDateValues] = useState({
        year: currentDate.getFullYear() - 40,
        month: currentDate.getMonth() + 1,
        day: null,
    });
    const types = {
        year: {
            key: "year",
            views: ["year"],
            value: moment(`01/01/${dateValues.year}`),
            format: "YYYY",
            next: "month",
        },
        month: {
            key: "month",
            views: ["year", "month"],
            value: moment(`${dateValues.month || "01"}/01/${dateValues.year}`),
            format: "MM",
            next: "day",
        },
        day: {
            key: "day",
            views: ["year", "month", "day"],
            value: moment(dateValues.day || `${dateValues.month}/01/${dateValues.year}`),
            format: "MM/DD/YYYY",
            next: null,
        },
    };

    const updateDateValues = (key, val) => {
        setDateValues({
            ...dateValues,
            [key]: val,
        });
    };

    const changeEvent = (date) => {
        let d = date.format(types[currentType].format);
        updateDateValues(types[currentType].key, d);

        if (types[currentType].next) {
            delay(() => {
                setCurrentType(types[currentType].next);
            }, 300);
        }
    };

    return (
        <div id="custom-date-picker-element">
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <StaticDatePicker
                    label="Date"
                    key={currentType}
                    openTo={currentType}
                    views={types[currentType].views}
                    value={types[currentType].value}
                    onChange={currentType == "day" ? changeEvent : () => {}}
                    onYearChange={changeEvent}
                    onMonthChange={changeEvent}
                    slotProps={{
                        day: {
                            sx: {
                                "&.MuiPickersDay-root.Mui-selected": {
                                    backgroundColor: "#000",
                                },
                                "&.MuiPickersYear-yearButton.Mui-selected": {
                                    backgroundColor: "#000",
                                },
                                "&.MuiPickersYear-root.Mui-selected": {
                                    backgroundColor: "#000",
                                },

                            }
                        },
                        month: {
                            sx: {
                                "&.MuiPickersMonth-root.Mui-selected": {
                                    backgroundColor: "#000",
                                },
                            },
                        },
                        actionBar: {
                            sx: {
                                "&.MuiPickersLayout-actionBar": { display: "none" },
                            },
                        },
                    }}
                />
            </LocalizationProvider>
            <div className="custom-sdp-footer-action">
                <span
                    onClick={() => {
                        ShowModal && ShowModal(false);
                    }}
                >
                    CANCEL
                </span>
                <span
                    onClick={() => {
                        if (types[currentType].next) {
                            setCurrentType(types[currentType].next);
                        } else {
                            onDateChange && onDateChange(types?.day?.value);
                            ShowModal && ShowModal(false);
                        }
                    }}
                >
                    OK
                </span>
            </div>
        </div>
    );
}

export default DatePicker;
